<template>
  <div id="lom-award-preview" class="professional-preview-dialog">
    <v-card class="main-preview-container" elevation="8">
      <!-- Professional Header -->
      <div class="professional-app-bar">
        <div class="app-bar-background">
          <div class="background-pattern"></div>
          <div class="background-overlay"></div>
        </div>

        <div class="app-bar-content">
          <div class="left-section">
            <div class="app-bar-icon-wrapper">
              <v-icon size="32" color="white" class="app-bar-icon"
                >mdi-trophy-award</v-icon
              >
            </div>
            <div class="title-content">
              <h1 class="app-bar-title">{{ PageTitle }}</h1>
            </div>
          </div>

          <div class="right-section">
            <div class="action-buttons-wrapper">
              <v-btn @click="closePrompt" class="close-button" outlined>
                <v-icon left size="18">mdi-close</v-icon>
                Close
              </v-btn>
            </div>
          </div>
        </div>
      </div>

      <!-- Professional Loading State -->
      <div class="professional-loading-section" v-if="LoadingFlag">
        <div class="loading-container">
          <v-progress-circular
            indeterminate
            size="64"
            width="4"
            color="#1976d2"
          ></v-progress-circular>
          <p class="loading-text mt-4">Loading award details...</p>
        </div>
      </div>

      <!-- Main Content -->
      <v-card-text
        class="main-content-wrapper"
        v-if="row != '' && !LoadingFlag"
      >
        <v-container class="py-0">
          <!-- Award Status Section -->
          <div class="award-section-card mb-4">
            <div class="section-header">
              <div class="section-title-wrapper">
                <v-icon size="24" color="#1976d2" class="mr-2"
                  >mdi-certificate</v-icon
                >
                <h3 class="section-title">Award Details</h3>
              </div>
            </div>

            <div class="section-content">
              <v-row>
                <v-col cols="12" sm="6" lg="3">
                  <div class="detail-item">
                    <h6 class="detail-label">Award Status</h6>
                    <div class="status-chip-wrapper">
                      <v-chip
                        :color="row.AwardStatusColor"
                        class="status-chip elevation-2"
                        label
                      >
                        <v-icon left size="16">mdi-flag</v-icon>
                        {{ row.AwardStatusTxt }}
                      </v-chip>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" lg="3">
                  <div class="detail-item">
                    <h6 class="detail-label">Register Number</h6>
                    <p class="detail-value">{{ row.AwardRegisterNumber }}</p>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" lg="3">
                  <div class="detail-item">
                    <h6 class="detail-label">Award Type</h6>
                    <p class="detail-value">{{ row.AwardTypeTitleTxt }}</p>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" lg="3">
                  <div class="detail-item">
                    <h6 class="detail-label">Award Category</h6>
                    <p class="detail-value">{{ row.AwardCategoryName }}</p>
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>
          <!-- Member Information Section -->
          <div class="award-section-card mb-4">
            <div class="section-header">
              <div class="section-title-wrapper">
                <v-icon size="24" color="#1976d2" class="mr-2"
                  >mdi-account-circle</v-icon
                >
                <h3 class="section-title">Nominee Details</h3>
              </div>
            </div>

            <div class="section-content">
              <!-- Member Photo -->
              <div class="member-photo-section" v-if="row.MemberImage != ''">
                <div class="photo-container">
                  <v-avatar size="120" class="member-avatar elevation-4">
                    <v-img
                      :src="row.MemberImage"
                      :alt="row.MemberFullName"
                      cover
                    ></v-img>
                  </v-avatar>
                  <div class="photo-overlay">
                    <v-icon color="white" size="20">mdi-camera</v-icon>
                  </div>
                </div>
              </div>

              <!-- Member Details -->
              <v-row class="mt-4">
                <v-col cols="12" sm="6" lg="3">
                  <div class="detail-item">
                    <h6 class="detail-label">
                      <v-icon size="16" class="mr-1">mdi-account</v-icon>
                      Full Name
                    </h6>
                    <p class="detail-value">{{ row.MemberFullName }}</p>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" lg="3">
                  <div class="detail-item">
                    <h6 class="detail-label">
                      <v-icon size="16" class="mr-1">mdi-account-box</v-icon>
                      Membership ID
                    </h6>
                    <p class="detail-value">{{ row.MembershipId }}</p>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" lg="3">
                  <div class="detail-item">
                    <h6 class="detail-label">
                      <v-icon size="16" class="mr-1">mdi-email</v-icon>
                      Email Address
                    </h6>
                    <p class="detail-value">{{ row.EmailId }}</p>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" lg="3">
                  <div class="detail-item">
                    <h6 class="detail-label">
                      <v-icon size="16" class="mr-1">mdi-phone</v-icon>
                      Mobile Number
                    </h6>
                    <p class="detail-value">{{ row.MobileNo }}</p>
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>
          <!-- Score card -->
          <div
            class="award-section-card mb-4 score-details-section animate-fade-in"
          >
            <div class="section-header">
              <div class="section-title-wrapper">
                <v-icon size="24" color="#7c4dff" class="mr-2 animate-icon"
                  >mdi-chart-bar</v-icon
                >
                <h3 class="section-title">Score Details</h3>
              </div>
            </div>
            <div class="section-content">
              <v-row wrap class="justify-center">
                <v-col cols="12">
                  <v-card
                    v-if="
                      row.AwardJciPointsData &&
                      Array.isArray(row.AwardJciPointsData) &&
                      row.AwardJciPointsData.length
                    "
                    class="pa-4 elevation-3 rounded-xl score-card animate-slide-up full-width-card"
                  >
                    <h5
                      class="text-center mb-4 font-weight-bold deep-purple--text score-title animate-title"
                    >
                      JCI Points Summary
                    </h5>
                    <v-simple-table class="award-jci-table responsive-table">
                      <thead>
                        <tr>
                          <th class="text-center">Criteria</th>
                          <th class="text-center">Max Points</th>
                          <th class="text-center">Received Points</th>
                        </tr>
                      </thead>
                      <tbody>
                        <template
                          v-for="(item, index) in row.AwardJciPointsData"
                        >
                          <tr
                            :key="'row-' + index"
                            class="score-row animate-row-fade"
                          >
                            <td
                              class="font-weight-medium criteria-cell"
                              style="height: 73px"
                            >
                              <v-icon
                                size="18"
                                color="#7c4dff"
                                class="mr-1 animate-icon"
                                >mdi-check-circle</v-icon
                              >
                              <span class="criteria-text">{{
                                item.Criteria
                              }}</span>
                            </td>
                            <td class="max-points-cell">
                              {{ item.MaxPoints }}
                            </td>
                            <td>
                              <v-chip
                                class="font-weight-bold score-chip animate-chip"
                                :style="{
                                  backgroundColor: item.PointsColor
                                    ? item.PointsColor
                                    : '#ede7f6',
                                  color: '#222',
                                  fontSize: '16px',
                                  minWidth: '48px',
                                  justifyContent: 'center',
                                  boxShadow: '0 2px 8px rgba(124,77,255,0.10)',
                                  transition: 'transform 0.3s',
                                }"
                                large
                                @mouseover="
                                  (e) =>
                                    (e.target.style.transform = 'scale(1.12)')
                                "
                                @mouseleave="
                                  (e) => (e.target.style.transform = 'scale(1)')
                                "
                              >
                                {{ item.ReceivedPoints }}
                              </v-chip>
                            </td>
                          </tr>
                        </template>
                        <!-- Total row -->
                        <tr class="score-total-row animate-row-fade">
                          <td class="font-weight-bold text-left" colspan="2">
                            <v-icon
                              size="18"
                              color="#1976d2"
                              class="mr-1 animate-icon"
                              >mdi-sigma</v-icon
                            >
                            Total
                          </td>
                          <td class="font-weight-bold">
                            <transition name="number-fade">
                              <span>
                                {{
                                  row.AwardJciPointsData.reduce(
                                    (sum, item) =>
                                      sum + Number(item.ReceivedPoints || 0),
                                    0
                                  )
                                }}
                              </span>
                            </transition>
                          </td>
                          <td></td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-card>
                  <v-card v-else class="award-section-card">
                    <div class="no-score-data text-center py-6">
                      <v-icon
                        color="#bdbdbd"
                        size="64"
                        class="mb-3 animate-icon"
                        >mdi-alert-circle-outline</v-icon
                      >
                      <h4
                        class="grey--text text--darken-1 font-weight-bold mb-2"
                      >
                        No JCI Points Found
                      </h4>
                      <p class="grey--text mb-0">
                        JCI Points Summary will be displayed here once
                        evaluation data becomes available.
                      </p>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </div>
          <hr />
          <!-- Judging Criteria Section -->
          <div class="award-section-card">
            <div class="section-header">
              <div class="section-title-wrapper">
                <v-icon size="24" color="#1976d2" class="mr-2"
                  >mdi-clipboard-list</v-icon
                >
                <h3 class="section-title">Judging Criteria Details</h3>
              </div>
            </div>

            <div class="section-content">
              <div
                v-for="(item, index) in row.AwardAnswersArray"
                :key="index"
                class="criteria-item-wrapper"
              >
                <!-- Criteria Title -->
                <div
                  class="criteria-title-section"
                  v-if="item.CriteriaTitleFlag"
                >
                  <div class="criteria-title-card">
                    <div class="criteria-title-content">
                      <h4 class="criteria-main-title">
                        <v-icon size="20" color="#4caf50" class="mr-2"
                          >mdi-bookmark</v-icon
                        >
                        {{ item.CriteriaTitle }}
                      </h4>
                      <div class="criteria-score-badge">
                        <v-chip
                          color="#4caf50"
                          text-color="white"
                          small
                          class="score-chip"
                        >
                          <v-icon left size="14">mdi-star</v-icon>
                          Score: {{ item.CriteriaScore }}
                        </v-chip>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Question and Answer -->
                <div class="question-answer-section">
                  <div class="question-card">
                    <div class="question-header">
                      <v-icon size="18" color="#ff9800" class="mr-2"
                        >mdi-help-circle</v-icon
                      >
                      <h6 class="question-label">Question</h6>
                    </div>
                    <p class="question-text">{{ item.QuestionsText }}</p>
                  </div>

                  <div class="answer-card mt-3">
                    <div class="answer-header">
                      <v-icon size="18" color="#2196f3" class="mr-2"
                        >mdi-message-reply</v-icon
                      >
                      <h6 class="answer-label">Answer</h6>
                    </div>
                    <div class="answer-content">
                      <p class="answer-text" v-html="item.AnswerText"></p>
                    </div>
                  </div>
                </div>

                <!-- Event Attachments -->
                <div
                  class="attachments-section"
                  v-if="item.EventDetails.length > 0"
                >
                  <div class="attachments-header">
                    <div class="attachments-title-wrapper">
                      <v-icon size="20" color="#9c27b0" class="mr-2"
                        >mdi-attachment</v-icon
                      >
                      <h6 class="attachments-title">
                        Award Attachments
                        <span class="attachment-count"
                          >(Max: {{ item.QuestionsAttachmentMax }})</span
                        >
                      </h6>
                    </div>
                  </div>

                  <div class="attachments-grid">
                    <v-row>
                      <v-col
                        cols="12"
                        sm="6"
                        md="4"
                        lg="3"
                        v-for="(data, k) in item.EventDetails"
                        :key="k"
                      >
                        <v-card class="attachment-card elevation-3">
                          <div class="attachment-card-header">
                            <v-icon color="white" size="20"
                              >mdi-calendar-check</v-icon
                            >
                            <span class="attachment-card-title"
                              >Event {{ k + 1 }}</span
                            >
                          </div>

                          <v-card-text class="attachment-content">
                            <!-- Event Images -->
                            <div
                              class="event-images-section"
                              v-if="
                                data.EventImagesArray &&
                                data.EventImagesArray.length > 0
                              "
                            >
                              <viewer rebuild :images="data.EventImagesArray">
                                <div class="images-gallery">
                                  <div
                                    class="image-thumbnail"
                                    v-for="(
                                      src, imgIndex
                                    ) in data.EventImagesArray"
                                    :key="imgIndex"
                                  >
                                    <img
                                      :src="src"
                                      :alt="`Event image ${imgIndex + 1}`"
                                      class="thumbnail-image"
                                    />
                                    <div class="image-overlay">
                                      <v-icon color="white" size="16"
                                        >mdi-magnify-plus</v-icon
                                      >
                                    </div>
                                  </div>
                                </div>
                              </viewer>
                            </div>

                            <!-- Event Details -->
                            <div class="event-details-section">
                              <div class="event-detail-item">
                                <div class="detail-icon-wrapper">
                                  <v-icon size="16" color="#1976d2"
                                    >mdi-calendar</v-icon
                                  >
                                </div>
                                <div class="detail-content">
                                  <span class="detail-label-small">Date</span>
                                  <span class="detail-value-small">{{
                                    data.EventDate
                                  }}</span>
                                </div>
                              </div>

                              <div class="event-detail-item mt-2">
                                <div class="detail-icon-wrapper">
                                  <v-icon size="16" color="#1976d2"
                                    >mdi-calendar-star</v-icon
                                  >
                                </div>
                                <div class="detail-content">
                                  <span class="detail-label-small">Event</span>
                                  <span class="detail-value-small">{{
                                    data.EventName
                                  }}</span>
                                </div>
                              </div>
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </div>
                </div>

                <!-- Divider between criteria items -->
                <v-divider
                  class="criteria-divider"
                  v-if="index < row.AwardAnswersArray.length - 1"
                ></v-divider>
              </div>
            </div>
          </div>
        </v-container>
      </v-card-text>

      <!-- Professional Footer Actions -->
      <v-card-actions class="professional-footer-actions">
        <div class="footer-content-centered">
          <v-btn
            @click="closePrompt"
            class="professional-close-btn"
            large
            elevation="3"
            color="#1976d2"
          >
            <v-icon left size="20">mdi-close-circle</v-icon>
            Close Preview
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {},
  props: {
    previewRecordPrompt: {
      required: true,
      Type: Boolean,
    },
    recordData: {
      required: true,
    },
  },
  data() {
    return {
      valid1: true,
      search: "",
      StartupLoadingFlag: false,
      LoadingFlag: false,
      SubmitFlag: false,

      ProgessStart: 0,
      uploadPercentage: 0,

      tab: "",

      row: [],

      addRecordPrompt: false,
      editRecordPrompt: false,

      ActiveStatus: "",

      valid: true,

      RoleId: "",
      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      CurrentYearId: 0,
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
    };
  },
  computed: {},
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        var flag = tr.PagePermissionFlag;
        console.log("PagePermissionFlag=" + flag);

        if (!flag) {
          this.$router.push("/access-denied");
        }

        var zone_name = this.$session.get("ZoneName");
        zone_name = zone_name == (null || undefined) ? 0 : zone_name;

        this.PageTitle = tr.PageTitle + " - " + zone_name;
        this.PageDescription = tr.PageDescription;
        this.FloatingButtonOptions = tr.FloatingButtonOptions;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        this.CurrentYearId = CurrentJciYearId;

        this.pageData();
      }
    },
  },
  created() {
    // this.initialize()
  },
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "zone_lom_award",
        Action: "preview",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    printPreview() {
      console.log("printPreview called");
      // Add print functionality if needed
      window.print();
    },
    downloadPDF() {
      console.log("downloadPDF called");
      // Add PDF download functionality if needed
      this.toast("info", "PDF download feature coming soon");
    },
    pageData() {
      console.log("pageData called");
      var recordData = this.recordData;
      console.log({ recordData });
      this.getTableRecords();
    },
    closePrompt() {
      console.log("closePrompt called");
      this.$emit("hidePreviewRecordPrompt");
    },
    getTableRecords() {
      console.log("getTableRecords called");

      var AwardId = this.recordData.AwardId;
      console.log({ AwardId });

      if (AwardId > 0) {
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/award/show";
        var upload = {
          UserInterface: 1,
          Award: AwardId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.LoadingFlag = true;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.LoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            if (flag == 1) {
              console.log("records=" + JSON.stringify(records));
              thisIns.row = records;
              thisIns.toast("success", output);
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.toast("error", error);
            thisIns.LoadingFlag = false;
          });
      } else {
        var message = "Award details not found.";
        console.log("error=" + message);
      }
    },
  },
  beforeMount() {
    console.log("beforeMount called");

    // var RoleId = this.$session.get("RoleId");
    // RoleId = RoleId == (null || undefined) ? "" : RoleId;
    // console.log({ RoleId });
    // this.RoleId = RoleId;

    this.refreshPageData();
  },
};
</script>

<style lang="scss">
// Professional Preview Dialog Styles
#lom-award-preview {
  .professional-preview-dialog {
    background-color: rgba(0, 0, 0, 0.05);
  }

  // Main Container
  .main-preview-container {
    border-radius: 16px !important;
    overflow: hidden;
    max-width: 100%;
    background: #ffffff;
    box-shadow: 0 8px 40px rgba(0, 0, 0, 0.12) !important;
  }
  // Full width score card
  .full-width-card {
    width: 100%;
    max-width: 100vw !important;
    margin: 0 !important;
    border-radius: 24px !important;
    box-shadow: 0 8px 32px rgba(124, 77, 255, 0.12);
    background: linear-gradient(90deg, #ede7f6 0%, #f3e5f5 100%);
    transition: box-shadow 0.3s, transform 0.3s;
    animation: fadeIn 0.7s;
    &:hover {
      box-shadow: 0 12px 40px rgba(124, 77, 255, 0.18);
      transform: translateY(-2px) scale(1.01);
    }
    .score-title {
      font-size: 1.35rem;
      color: #7c4dff;
      font-weight: 700;
      letter-spacing: 0.02em;
      animation: fadeIn 0.7s;
    }
  }

  // Responsive for full width card
  @media (max-width: 1024px) {
    .full-width-card {
      border-radius: 18px !important;
      padding: 1.5rem !important;
    }
  }
  @media (max-width: 768px) {
    .full-width-card {
      border-radius: 14px !important;
      padding: 1rem !important;
    }
    .score-title {
      font-size: 1.1rem;
    }
  }
  @media (max-width: 480px) {
    .full-width-card {
      border-radius: 8px !important;
      padding: 0.5rem !important;
    }
    .score-title {
      font-size: 0.95rem;
    }
  }
  // Enhanced Score Card Section
  .score-details-section {
    .section-header {
      background: linear-gradient(135deg, #ede7f6 0%, #e3f2fd 100%);
      border-bottom: 1px solid rgba(124, 77, 255, 0.12);
      .section-title {
        color: #7c4dff;
        font-size: 1.3rem;
        font-weight: 700;
        letter-spacing: 0.01em;
      }
    }
    .section-content {
      padding: 2rem 1rem;
    }
  }

  .score-card {
    background: linear-gradient(135deg, #f3e5f5 0%, #ede7f6 100%);
    border: 1px solid #d1c4e9;
    box-shadow: 0 4px 18px rgba(124, 77, 255, 0.1);
    border-radius: 20px;
    transition: box-shadow 0.3s, transform 0.3s;
    &:hover {
      box-shadow: 0 8px 32px rgba(124, 77, 255, 0.18);
      transform: translateY(-2px);
    }
    .score-title {
      color: #7c4dff;
      font-size: 1.2rem;
      letter-spacing: 0.02em;
      font-weight: 700;
      animation: fadeIn 0.7s;
    }
  }

  .award-jci-table.responsive-table {
    width: 100%;
    th,
    td {
      padding: 0.7rem 0.4rem;
      font-size: 1rem;
      text-align: center;
      vertical-align: middle;
    }
    th {
      background: #ede7f6;
      color: #7c4dff;
      font-weight: 600;
      border-bottom: 2px solid #d1c4e9;
    }
    td {
      background: #fff;
      border-bottom: 1px solid #f3e5f5;
      transition: background 0.3s;
    }
    .criteria-cell {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      .criteria-text {
        font-weight: 500;
        font-size: 1rem;
        color: #512da8;
      }
    }
    .max-points-cell {
      color: #512da8;
      font-weight: 500;
    }

    .score-chip {
      box-shadow: 0 2px 8px rgba(124, 77, 255, 0.1);
      transition: transform 0.3s, box-shadow 0.3s;
      cursor: pointer;
      border-radius: 8px !important;
      font-size: 1rem !important;
      font-weight: 600 !important;
      &:hover {
        box-shadow: 0 4px 16px rgba(124, 77, 255, 0.18);
        transform: scale(1.12);
      }
    }
    .score-row {
      animation: fadeInUp 0.6s;
      transition: background 0.3s;
      &:hover {
        background: #f3e5f5;
      }
    }
    .score-total-row {
      background: #ede7f6;
      font-size: 1.1rem;
      animation: fadeInUp 0.8s;
      font-weight: 700;
    }
  }

  // Subtle icon and title animations
  .animate-icon {
    animation: iconPop 0.7s;
  }
  .animate-title {
    animation: fadeIn 0.7s;
  }
  .animate-chip {
    animation: chipFade 0.7s;
  }

  // Animations
  .animate-fade-in {
    animation: fadeIn 0.7s;
  }
  .animate-slide-up {
    animation: slideUp 0.7s;
  }
  .animate-row-fade {
    animation: fadeInUp 0.6s;
  }
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  @keyframes iconPop {
    0% {
      transform: scale(0.7);
      opacity: 0;
    }
    60% {
      transform: scale(1.2);
      opacity: 1;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
  @keyframes chipFade {
    from {
      opacity: 0;
      transform: scale(0.8);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
  .number-fade-enter-active,
  .number-fade-leave-active {
    transition: opacity 0.5s;
  }
  .number-fade-enter,
  .number-fade-leave-to {
    opacity: 0;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.4s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  // Mobile responsiveness for score card
  @media (max-width: 768px) {
    .score-card {
      max-width: 98vw !important;
      padding: 1rem !important;
      border-radius: 14px !important;
    }
    .award-jci-table.responsive-table th,
    .award-jci-table.responsive-table td {
      font-size: 0.95rem;
      padding: 0.5rem 0.2rem;
    }
    .score-title {
      font-size: 1rem;
    }
  }
  @media (max-width: 480px) {
    .score-card {
      max-width: 100vw !important;
      padding: 0.5rem !important;
      border-radius: 10px !important;
    }
    .award-jci-table.responsive-table th,
    .award-jci-table.responsive-table td {
      font-size: 0.85rem;
      padding: 0.3rem 0.1rem;
    }
    .score-title {
      font-size: 0.95rem;
    }
  }
  // Score Details Section (custom)
  .score-details-section {
    .section-header {
      background: linear-gradient(135deg, #ede7f6 0%, #e3f2fd 100%);
      border-bottom: 1px solid rgba(124, 77, 255, 0.12);
      .section-title {
        color: #7c4dff;
      }
    }
    .section-content {
      padding: 2rem 1rem;
    }
  }

  .score-card {
    background: linear-gradient(135deg, #f3e5f5 0%, #ede7f6 100%);
    border: 1px solid #d1c4e9;
    box-shadow: 0 4px 18px rgba(124, 77, 255, 0.08);
    border-radius: 16px;
    transition: box-shadow 0.3s, transform 0.3s;
    &:hover {
      box-shadow: 0 8px 32px rgba(124, 77, 255, 0.15);
      transform: translateY(-2px);
    }
    .score-title {
      color: #7c4dff;
      font-size: 1.25rem;
      letter-spacing: 0.02em;
    }
  }

  .award-jci-table {
    th {
      background: #ede7f6;
      color: #7c4dff;
      font-weight: 600;
      font-size: 1rem;
      border-bottom: 2px solid #d1c4e9;
      text-align: center;
      padding: 0.75rem;
    }
    td {
      background: #fff;
      font-size: 1rem;
      padding: 0.75rem;
      border-bottom: 1px solid #f3e5f5;
      transition: background 0.3s;
    }
    .criteria-cell {
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }
    .max-points-cell {
      text-align: center;
      color: #512da8;
      font-weight: 500;
    }

    .score-chip {
      box-shadow: 0 2px 8px rgba(124, 77, 255, 0.15);
      transition: transform 0.3s;
      cursor: pointer;
    }
    .score-row {
      animation: fadeInUp 0.6s;
    }
    .score-total-row {
      background: #ede7f6;
      font-size: 1.1rem;
      animation: fadeInUp 0.8s;
    }
  }

  // Animations
  .animate-fade-in {
    animation: fadeIn 0.7s;
  }
  .animate-slide-up {
    animation: slideUp 0.7s;
  }
  .animate-row-fade {
    animation: fadeInUp 0.6s;
  }
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  .number-fade-enter-active,
  .number-fade-leave-active {
    transition: opacity 0.5s;
  }
  .number-fade-enter,
  .number-fade-leave-to {
    opacity: 0;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.4s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  // Professional Header
  .professional-preview-header {
    .header-gradient {
      background: linear-gradient(
        135deg,
        #1976d2 0%,
        #1565c0 50%,
        #0d47a1 100%
      );
      position: relative;
      overflow: hidden;

      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="25" cy="25" r="1" fill="rgba(255,255,255,0.1)"/><circle cx="75" cy="75" r="1" fill="rgba(255,255,255,0.1)"/><circle cx="50" cy="10" r="0.5" fill="rgba(255,255,255,0.1)"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>');
        opacity: 0.3;
      }

      .header-content {
        position: relative;
        z-index: 1;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .title-section {
          flex: 1;

          .title-wrapper {
            display: flex;
            align-items: center;

            .preview-main-title {
              font-size: 1.75rem;
              font-weight: 700;
              color: white;
              margin: 0;
              text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
            }

            .preview-subtitle {
              font-size: 1rem;
              color: rgba(255, 255, 255, 0.9);
              margin: 4px 0 0 0;
              font-weight: 400;
            }
          }
        }

        .action-section {
          .close-btn {
            background: rgba(255, 255, 255, 0.15);
            backdrop-filter: blur(10px);
            border: 1px solid rgba(255, 255, 255, 0.2);
            transition: all 0.3s ease;

            &:hover {
              background: rgba(255, 255, 255, 0.25);
              transform: scale(1.05);
            }
          }
        }
      }
    }
  }

  // Professional App Bar
  .professional-app-bar {
    position: relative;
    min-height: 80px;
    display: flex;
    align-items: center;
    overflow: hidden;

    .app-bar-background {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(
        135deg,
        #1565c0 0%,
        #1976d2 25%,
        #1e88e5 50%,
        #2196f3 75%,
        #42a5f5 100%
      );

      .background-pattern {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-image: radial-gradient(
            circle at 25% 25%,
            rgba(255, 255, 255, 0.1) 2px,
            transparent 2px
          ),
          radial-gradient(
            circle at 75% 75%,
            rgba(255, 255, 255, 0.08) 1px,
            transparent 1px
          ),
          radial-gradient(
            circle at 50% 10%,
            rgba(255, 255, 255, 0.05) 1.5px,
            transparent 1.5px
          );
        background-size: 60px 60px, 40px 40px, 80px 80px;
        animation: patternFloat 20s ease-in-out infinite;
      }

      .background-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.1);
      }
    }

    .app-bar-content {
      position: relative;
      z-index: 2;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      padding: 1.25rem 2rem;

      .left-section {
        display: flex;
        align-items: center;
        flex: 1;

        .app-bar-icon-wrapper {
          margin-right: 1.5rem;

          .app-bar-icon {
            background: rgba(255, 255, 255, 0.15);
            border-radius: 12px;
            padding: 0.5rem;
            backdrop-filter: blur(10px);
            border: 1px solid rgba(255, 255, 255, 0.2);
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
          }
        }

        .title-content {
          .app-bar-title {
            font-size: 1.75rem;
            font-weight: 700;
            color: white;
            margin: 0 0 0.25rem 0;
            text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
            letter-spacing: -0.025em;
          }

          .app-bar-breadcrumb {
            display: flex;
            align-items: center;
            font-size: 0.875rem;
            color: rgba(255, 255, 255, 0.8);

            .breadcrumb-item {
              opacity: 0.8;
              transition: opacity 0.2s ease;

              &:hover {
                opacity: 1;
              }
            }

            .breadcrumb-current {
              color: rgba(255, 255, 255, 1);
              font-weight: 500;
            }
          }
        }
      }

      .right-section {
        .action-buttons-wrapper {
          display: flex;
          align-items: center;
          gap: 0.5rem;

          .action-btn {
            background: rgba(255, 255, 255, 0.1) !important;
            border: 1px solid rgba(255, 255, 255, 0.2) !important;
            backdrop-filter: blur(10px);
            transition: all 0.3s ease !important;
            width: 40px !important;
            height: 40px !important;

            &:hover {
              background: rgba(255, 255, 255, 0.2) !important;
              transform: translateY(-2px);
              box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
            }
          }

          .divider-line {
            width: 1px;
            height: 32px;
            background: rgba(255, 255, 255, 0.3);
            margin: 0 0.75rem;
          }

          .close-button {
            background: rgba(255, 255, 255, 0.15) !important;
            border: 2px solid rgba(255, 255, 255, 0.3) !important;
            color: white !important;
            font-weight: 600 !important;
            text-transform: none !important;
            padding: 0 1.5rem !important;
            height: 42px !important;
            border-radius: 21px !important;
            backdrop-filter: blur(10px);
            transition: all 0.3s ease !important;

            &:hover {
              background: rgba(255, 255, 255, 0.25) !important;
              border-color: rgba(255, 255, 255, 0.5) !important;
              transform: translateY(-2px);
              box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
            }

            &::before {
              display: none !important;
            }
          }
        }
      }
    }
  }

  @keyframes patternFloat {
    0%,
    100% {
      transform: translateY(0) rotate(0deg);
    }
    50% {
      transform: translateY(-10px) rotate(180deg);
    }
  }

  // Professional Loading
  .professional-loading-section {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 300px;
    background: linear-gradient(45deg, #f5f7fa 0%, #c3cfe2 100%);

    .loading-container {
      text-align: center;

      .loading-text {
        font-size: 1.1rem;
        color: #1976d2;
        font-weight: 500;
        margin: 0;
      }
    }
  }

  // Main Content
  .main-content-wrapper {
    background: linear-gradient(to bottom, #f8f9fa 0%, #ffffff 100%);
    padding: 2rem !important;
  }

  // Award Section Cards
  .award-section-card {
    background: white;
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    border: 1px solid rgba(25, 118, 210, 0.1);
    overflow: hidden;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
      transform: translateY(-2px);
    }

    .section-header {
      background: linear-gradient(135deg, #f8f9fa 0%, #e3f2fd 100%);
      padding: 1.5rem 2rem;
      border-bottom: 1px solid rgba(25, 118, 210, 0.1);

      .section-title-wrapper {
        display: flex;
        align-items: center;

        .section-title {
          font-size: 1.4rem;
          font-weight: 600;
          color: #2c3e50;
          margin: 0;
        }
      }
    }

    .section-content {
      padding: 2rem;
    }
  }

  // Detail Items
  .detail-item {
    .detail-label {
      font-size: 0.875rem;
      font-weight: 600;
      color: #1976d2;
      margin-bottom: 0.5rem;
      display: flex;
      align-items: center;
    }

    .detail-value {
      font-size: 1rem;
      color: #2c3e50;
      font-weight: 500;
      margin: 0;
      padding: 0.75rem 1rem;
      background: #f8f9fa;
      border-radius: 8px;
      border-left: 4px solid #1976d2;
    }
  }

  // Status Chip
  .status-chip-wrapper {
    .status-chip {
      font-weight: 600 !important;
      font-size: 0.875rem !important;
      padding: 0 16px !important;
      height: 36px !important;
      color: white !important;
    }
  }

  // Member Photo Section
  .member-photo-section {
    display: flex;
    justify-content: center;
    margin-bottom: 1rem;

    .photo-container {
      position: relative;
      display: inline-block;

      .member-avatar {
        border: 4px solid #e3f2fd;
        transition: all 0.3s ease;

        &:hover {
          border-color: #1976d2;
          transform: scale(1.05);
        }
      }

      .photo-overlay {
        position: absolute;
        bottom: 0;
        right: 0;
        background: #1976d2;
        border-radius: 50%;
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 3px solid white;
      }
    }
  }

  // Criteria Items
  .criteria-item-wrapper {
    margin-bottom: 2rem;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .criteria-title-section {
    margin-bottom: 1.5rem;

    .criteria-title-card {
      background: linear-gradient(135deg, #e8f5e8 0%, #f1f8e9 100%);
      border: 1px solid #4caf50;
      border-radius: 12px;
      padding: 1.5rem;

      .criteria-title-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        gap: 1rem;

        .criteria-main-title {
          font-size: 1.3rem;
          font-weight: 600;
          color: #2e7d32;
          margin: 0;
          display: flex;
          align-items: center;
        }

        .criteria-score-badge {
          .score-chip {
            font-weight: 600 !important;
          }
        }
      }
    }
  }

  // Question Answer Section
  .question-answer-section {
    .question-card,
    .answer-card {
      background: white;
      border-radius: 12px;
      padding: 1.25rem;
      border: 1px solid #e0e0e0;

      .question-header,
      .answer-header {
        display: flex;
        align-items: center;
        margin-bottom: 0.75rem;

        .question-label,
        .answer-label {
          font-size: 1rem;
          font-weight: 600;
          margin: 0;
        }
      }

      .question-text,
      .answer-text {
        font-size: 1rem;
        line-height: 1.6;
        color: #424242;
        margin: 0;
      }
    }

    .question-card {
      border-left: 4px solid #ff9800;
      background: #fff3e0;

      .question-label {
        color: #f57c00;
      }
    }

    .answer-card {
      border-left: 4px solid #2196f3;
      background: #e3f2fd;

      .answer-label {
        color: #1976d2;
      }

      .answer-content {
        background: white;
        padding: 1rem;
        border-radius: 8px;
        border: 1px solid #e1f5fe;
      }
    }
  }

  // Attachments Section
  .attachments-section {
    margin-top: 2rem;

    .attachments-header {
      margin-bottom: 1.5rem;

      .attachments-title-wrapper {
        display: flex;
        align-items: center;

        .attachments-title {
          font-size: 1.1rem;
          font-weight: 600;
          color: #7b1fa2;
          margin: 0;

          .attachment-count {
            font-size: 0.875rem;
            color: #9c27b0;
            font-weight: 400;
          }
        }
      }
    }

    .attachments-grid {
      .attachment-card {
        border-radius: 12px !important;
        overflow: hidden;
        transition: all 0.3s ease;
        border: 1px solid #e1bee7;

        &:hover {
          transform: translateY(-4px);
          box-shadow: 0 8px 25px rgba(156, 39, 176, 0.15) !important;
        }

        .attachment-card-header {
          background: linear-gradient(135deg, #9c27b0 0%, #7b1fa2 100%);
          color: white;
          padding: 0.75rem 1rem;
          display: flex;
          align-items: center;
          gap: 0.5rem;

          .attachment-card-title {
            font-weight: 600;
            font-size: 0.875rem;
          }
        }

        .attachment-content {
          padding: 1rem !important;
        }
      }
    }
  }

  // Event Images
  .event-images-section {
    margin-bottom: 1rem;

    .images-gallery {
      display: flex;
      flex-wrap: wrap;
      gap: 0.5rem;

      .image-thumbnail {
        position: relative;
        width: 60px;
        height: 60px;
        border-radius: 8px;
        overflow: hidden;
        cursor: pointer;
        transition: all 0.3s ease;

        &:hover {
          transform: scale(1.1);

          .image-overlay {
            opacity: 1;
          }
        }

        .thumbnail-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .image-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.6);
          display: flex;
          align-items: center;
          justify-content: center;
          opacity: 0;
          transition: opacity 0.3s ease;
        }
      }
    }
  }

  // Event Details
  .event-details-section {
    .event-detail-item {
      display: flex;
      align-items: flex-start;
      gap: 0.75rem;

      .detail-icon-wrapper {
        margin-top: 0.125rem;
      }

      .detail-content {
        flex: 1;

        .detail-label-small {
          display: block;
          font-size: 0.75rem;
          font-weight: 600;
          color: #666;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          margin-bottom: 0.25rem;
        }

        .detail-value-small {
          display: block;
          font-size: 0.875rem;
          color: #2c3e50;
          font-weight: 500;
          line-height: 1.4;
        }
      }
    }
  }

  // Criteria Divider
  .criteria-divider {
    margin: 2rem 0;
    border-color: rgba(25, 118, 210, 0.2);
  }

  // Professional Footer
  .professional-footer-actions {
    background: linear-gradient(135deg, #f8f9fa 0%, #e3f2fd 100%);
    border-top: 1px solid rgba(25, 118, 210, 0.1);
    padding: 2rem !important;

    .footer-content-centered {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;

      .professional-close-btn {
        background: linear-gradient(
          135deg,
          #1976d2 0%,
          #1565c0 100%
        ) !important;
        color: white !important;
        font-weight: 600 !important;
        text-transform: none !important;
        border-radius: 12px !important;
        padding: 0 2rem !important;
        height: 48px !important;
        font-size: 1rem !important;
        box-shadow: 0 4px 15px rgba(25, 118, 210, 0.3) !important;
        transition: all 0.3s ease !important;
        border: none !important;

        &:hover {
          background: linear-gradient(
            135deg,
            #1565c0 0%,
            #0d47a1 100%
          ) !important;
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(25, 118, 210, 0.4) !important;
        }

        &:active {
          transform: translateY(0);
          box-shadow: 0 2px 8px rgba(25, 118, 210, 0.3) !important;
        }

        &::before {
          display: none !important;
        }

        .v-icon {
          margin-right: 0.5rem !important;
        }
      }
    }

    .footer-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;

      .footer-info {
        display: flex;
        align-items: center;

        .footer-text {
          font-size: 0.875rem;
          color: #666;
          margin-left: 0.25rem;
        }
      }

      .footer-actions {
        .close-action-btn {
          font-weight: 600 !important;
          text-transform: none !important;
          border-radius: 8px !important;
          border: 2px solid #1976d2 !important;
          color: #1976d2 !important;
          transition: all 0.3s ease !important;

          &:hover {
            background: #1976d2 !important;
            color: white !important;
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3);
          }
        }
      }
    }
  }

  // Responsive Design
  @media (max-width: 1024px) {
    .professional-app-bar {
      .app-bar-content {
        padding: 1rem 1.5rem;

        .left-section {
          .app-bar-icon-wrapper {
            margin-right: 1rem;
          }

          .title-content {
            .app-bar-title {
              font-size: 1.5rem;
            }

            .app-bar-breadcrumb {
              font-size: 0.8rem;
            }
          }
        }

        .right-section {
          .action-buttons-wrapper {
            gap: 0.25rem;

            .action-btn {
              width: 36px !important;
              height: 36px !important;
            }

            .close-button {
              padding: 0 1rem !important;
              height: 38px !important;
              font-size: 0.875rem !important;
            }
          }
        }
      }
    }

    .main-preview-container {
      margin: 0.5rem;
      border-radius: 12px !important;
    }

    .main-content-wrapper {
      padding: 1.5rem !important;
    }
  }

  @media (max-width: 768px) {
    .professional-app-bar {
      min-height: 70px;

      .app-bar-content {
        padding: 0.75rem 1rem;
        flex-direction: column;
        align-items: flex-start;
        gap: 1rem;

        .left-section {
          width: 100%;

          .app-bar-icon-wrapper {
            margin-right: 0.75rem;

            .app-bar-icon {
              padding: 0.375rem;
            }
          }

          .title-content {
            .app-bar-title {
              font-size: 1.25rem;
            }

            .app-bar-breadcrumb {
              font-size: 0.75rem;
              flex-wrap: wrap;
            }
          }
        }

        .right-section {
          width: 100%;

          .action-buttons-wrapper {
            justify-content: flex-end;
            width: 100%;

            .divider-line {
              display: none;
            }

            .close-button {
              width: auto !important;
              min-width: 120px !important;
            }
          }
        }
      }
    }

    .main-content-wrapper {
      padding: 1rem !important;
    }

    .award-section-card {
      .section-content {
        padding: 1rem;
      }
    }

    .criteria-title-content {
      flex-direction: column;
      align-items: flex-start !important;
    }

    .footer-content {
      flex-direction: column;
      gap: 1rem;
      text-align: center;

      .footer-actions {
        .professional-close-btn {
          width: 100%;
          min-width: 200px;
        }
      }
    }

    .footer-content-centered {
      .professional-close-btn {
        width: 100%;
        max-width: 280px;
      }
    }

    .images-gallery {
      justify-content: center;
    }
  }

  @media (max-width: 480px) {
    .professional-app-bar {
      min-height: 60px;

      .app-bar-content {
        padding: 0.5rem 0.75rem;

        .left-section {
          .title-content {
            .app-bar-title {
              font-size: 1.125rem;
            }

            .app-bar-breadcrumb {
              display: none; // Hide breadcrumb on very small screens
            }
          }
        }

        .right-section {
          .action-buttons-wrapper {
            .action-btn {
              width: 32px !important;
              height: 32px !important;
            }

            .close-button {
              font-size: 0.8rem !important;
              padding: 0 0.75rem !important;
              height: 34px !important;
            }
          }
        }
      }
    }

    .main-preview-container {
      margin: 0.25rem;
      border-radius: 8px !important;
    }
  }
}

// Legacy compatibility
#lom-award-create {
  @extend #lom-award-preview;
}
</style>
